export default __webpack_public_path__ + "static/media/Scythe.878eaefa.webp";